import { MatrixBuilder3, multiplyVectorMatrix } from './matrix';

export function scaleToViewBox(points: number[][], width: number, height: number, xMargin: number = 0, vMin?: number, vMax?: number): (number |null) [][] {
    let xs = points.map(p => p[0]);
    let ys = points.map(p => p[1]);

    let xMin = Math.min(...xs) - xMargin;
    let xMax = Math.max(...xs) + xMargin;
    let yMin = Math.min(...ys);
    let yMax = Math.max(...ys);

    if (vMin != undefined) {
        yMin = Math.min(yMin, vMin);
    }
    if (vMax != undefined) {
        yMax = Math.max(yMax, vMax);
    }

    if (yMin == yMax) {
        if (yMax == 0) {
            yMax = 1;
        }
        else if (yMax > 0) {
            yMin = 0;
        }
        else {
            yMax = 0;
        }
    }
    let sx = xMax > xMin ? width  / (xMax - xMin) : 1;
    let sy = yMax > yMin ? height / (yMax - yMin) : 1;

    let matrix = new MatrixBuilder3()
        .translate(-xMin, -yMin)
        .scale(sx, -sy)
        .translate(0, height)
        .build();

    return points.map(p => {
        if (p[1] === null) {
            p = multiplyVectorMatrix([p[0], 0], matrix);
            return [p[0], null];
        }
        else {
            return multiplyVectorMatrix(p, matrix).splice(0, 2);
        }
    });
}

export function scaleValue(value: number, min: number, max: number, l = 1) {
    return (value - min) / (max - min) * l;
}

export function safeMax(...args: any[]): number {
    let v = -Infinity;
    for (let a of args) {
        if (Array.isArray(a) && a.length > 0) {
            v = a.reduce((m, x) => x != null && x > m ? x : m, v);
        }
        else if (typeof a == 'number' && a > v) {
            v = a;
        }
    }
    return v;
}

export function safeMin(...args: any[]): number {
    let v = Infinity;
    for (let a of args) {
        if (Array.isArray(a)) {
            v = a.reduce((m, x) => x != null && x < m ? x : m, v);
        }
        else if (typeof a == 'number' && a < v) {
            v = a;
        }
    }
    return v;
}